import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {Address} from "./models/address.model";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.addresses')
  .factory('$addresses', AddressesObjectFactory);

export type $addressesFactory = (id?: string) => BringozArray<Address>;

/* @ngInject */
function AddressesObjectFactory($bringozFactory: $bringozFactory,
                                addressesAPI: BringozApi,
                                Addresses_DS: DataStoreConfig,
                                Addresses_PN: PushNotificationsConfig) {
  function $addresses(id?: string) {
    return $bringozFactory<Address>(id, addressesAPI, Addresses_DS, Addresses_PN);
  }

  return $addresses;
}
